export default __webpack_public_path__ + "static/media/section1-slide-B2.334a9908.jpg";